/**
 * Whether `/review` renders the Review v0 page instead of today's per-email
 * Inbox.
 *
 * `VITE_ENABLE_REVIEW_V0` decides when it is the literal string "true" or
 * "false". Otherwise it is on only where `VITE_APP_ENV` is `staging`, so QA
 * sees it on staging with no extra variable while a promotion of `main`
 * keeps production on today's Inbox until Step 1 is validated.
 */
export function isReviewV0Enabled(): boolean {
  const explicit = import.meta.env.VITE_ENABLE_REVIEW_V0;
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return import.meta.env.VITE_APP_ENV === 'staging';
}

/**
 * Whether the drawer reads `Add to Yaruta` instead of today's `Create new
 * item`, and a manager's opens the sheet that adds a photo or file (OCR v1,
 * YAR-556).
 *
 * Its own flag, independent of `isReviewV0Enabled()`: Meeting #168 ships OCR
 * to production first while Review Flow v2.0 stays off (Decision D1). The
 * upload backend ships unflagged but is reachable only through this UI, so a
 * promotion of `main` carries it dormant until `VITE_ENABLE_ADD_TO_YARUTA` is
 * set on Railway.
 *
 * `VITE_ENABLE_ADD_TO_YARUTA` decides when it is the literal string "true" or
 * "false". Otherwise it is on only where `VITE_APP_ENV` is `staging`.
 */
export function isAddToYarutaEnabled(): boolean {
  const explicit = import.meta.env.VITE_ENABLE_ADD_TO_YARUTA;
  if (explicit === 'true') return true;
  if (explicit === 'false') return false;
  return import.meta.env.VITE_APP_ENV === 'staging';
}
